import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-facebook-ads-identity',
  templateUrl: './help-facebook-ads-identity.component.html'
})
export class HelpFacebookAdsIdentityComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
